<script>
const year = new Date().getFullYear();
const name = "raheebwa";
// const githubURL = `http://github.com/${name}`
</script>

<footer class="card w-100 text-center bg-primary">
  <div class="container py-3">
    <span class="text-muted">&copy; {year}. {name}</span>
  </div>
</footer>

